export interface MotionPerformanceProfile {
  staticHeadline: boolean;
  dataFlowEnabled: boolean;
  nodeCount: number;
  frameInterval: number;
  useNodeGlow: boolean;
}

export function getMotionPerformanceProfile(
  viewportWidth: number,
  prefersReducedMotion: boolean,
): MotionPerformanceProfile {
  const compact = viewportWidth < 768;

  return {
    staticHeadline: compact || prefersReducedMotion,
    dataFlowEnabled: !prefersReducedMotion,
    nodeCount: compact ? 12 : 26,
    frameInterval: compact ? 33 : 20,
    useNodeGlow: !compact,
  };
}
